import React from "react";
import { getClassName } from "@sscs/utils";
import { Card, NoResultsFound, QueryResult, SortIcon, Table, } from "../../index";
import DataTableContext from "./context";
import styles from "./dataTable.module.scss";
import Details from "./ExpandedRow/Details";
import ExpandedRowRow from "./ExpandedRow/ExpandedRow";
import Summary from "./ExpandedRow/Summary";
import Pagination from "./Pagination";
const FLEX_FLOOR = 120;
const columnMinWidth = (column) => {
    var _a, _b;
    if ((_a = column.minWidth) === null || _a === void 0 ? void 0 : _a.endsWith("px"))
        return Number.parseFloat(column.minWidth);
    if ((_b = column.width) === null || _b === void 0 ? void 0 : _b.endsWith("px"))
        return Number.parseFloat(column.width);
    return FLEX_FLOOR;
};
const renderHeaderContent = (column, sort, onSortChange) => {
    var _a;
    if (column.header !== undefined)
        return column.header;
    if (column.sortProperty && sort && onSortChange) {
        return (React.createElement(SortIcon, { id: column.sortId, activeSort: sort, property: column.sortProperty, name: (_a = column.label) !== null && _a !== void 0 ? _a : "", startReverse: column.startReverse, handleSort: onSortChange }));
    }
    return column.label;
};
const DataTable = ({ id, columns, sort, onSortChange, status, empty, title, titleDetails, titleActions, size, hideHeader = false, chrome = "card", pagination, className, tableClassName, style, children, }) => {
    var _a;
    const isLoadingOrError = (status === null || status === void 0 ? void 0 : status.status) === "LOADING" || (status === null || status === void 0 ? void 0 : status.status) === "ERROR";
    if (isLoadingOrError) {
        return (React.createElement("div", { className: getClassName(styles.plain, className), style: style },
            React.createElement(QueryResult, { status: status })));
    }
    const visibleColumns = columns.filter((column) => !column.hidden);
    const minWidth = visibleColumns.reduce((sum, column) => sum + columnMinWidth(column), 0);
    const isEmpty = React.Children.count(children) === 0;
    const hasPagination = pagination
        ? pagination.itemCount > ((_a = pagination.initialItemCount) !== null && _a !== void 0 ? _a : 10)
        : false;
    const flush = chrome === "card" && !hasPagination;
    const tableClasses = getClassName(styles.table, {
        [styles["flush-bottom"]]: flush,
        [styles["min-column-width"]]: !hideHeader,
    }, tableClassName);
    const table = (React.createElement(Table.Container, null,
        React.createElement(Table.Table, { className: tableClasses, size: size, "aria-label": typeof title === "string" ? title : "data table", style: hideHeader
                ? undefined
                : {
                    "--data-table-min-width": `${minWidth}px`,
                } },
            React.createElement("colgroup", null, visibleColumns.map((column) => (React.createElement("col", { key: column.id, width: column.width })))),
            hideHeader ? null : (React.createElement(Table.Head, null,
                React.createElement(Table.Row, null, visibleColumns.map((column) => (React.createElement(Table.Cell, { key: column.id, align: column.align, className: column.headerClassName }, renderHeaderContent(column, sort, onSortChange))))))),
            React.createElement(Table.Body, null, isEmpty && empty !== undefined ? (React.createElement(NoResultsFound, { ...empty, colSpan: visibleColumns.length })) : (React.createElement(DataTableContext.Provider, { value: {
                    columnCount: visibleColumns.length,
                    flush,
                } }, children))))));
    const pager = pagination && hasPagination ? (React.createElement(Pagination, { ...pagination, className: getClassName(styles.pagination, pagination.className) })) : null;
    const body = (React.createElement(React.Fragment, null,
        title !== undefined ? (React.createElement(Card.Title, { className: chrome === "plain" ? styles.title : undefined, details: titleDetails, actions: titleActions }, title)) : null,
        status ? React.createElement(QueryResult, { status: status }, table) : table,
        pager));
    if (chrome === "plain") {
        return (React.createElement("div", { id: id, className: className, style: style, "data-datatable": "true", "data-empty": isEmpty ? "true" : undefined }, body));
    }
    return (React.createElement(Card.Card, { className: getClassName(styles.card, className), style: style, "data-datatable": "true", "data-empty": isEmpty ? "true" : undefined }, body));
};
/** Expandable row, reachable only through `DataTable` — it reads the visible column count from context. */
const ExpandedRow = Object.assign(ExpandedRowRow, { Summary, Details });
export default Object.assign(DataTable, { ExpandedRow });
//# sourceMappingURL=DataTable.js.map